import { createVNode as _createVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "w-lg-500px bg-white rounded shadow-sm p-10 p-lg-15 mx-auto" }
const _hoisted_2 = { class: "text-center mb-10" }
const _hoisted_3 = /*#__PURE__*/_createVNode("h1", { class: "text-dark mb-3" }, "Sign In to Metronic", -1)
const _hoisted_4 = { class: "text-gray-400 fw-bold fs-4" }
const _hoisted_5 = /*#__PURE__*/_createTextVNode(" New Here? ")
const _hoisted_6 = /*#__PURE__*/_createTextVNode(" Create an Account ")
const _hoisted_7 = /*#__PURE__*/_createVNode("div", { class: "mb-10 bg-light-info p-8 rounded" }, [
  /*#__PURE__*/_createVNode("div", { class: "text-info" }, [
    /*#__PURE__*/_createTextVNode(" Use account "),
    /*#__PURE__*/_createVNode("strong", null, "admin@demo.com"),
    /*#__PURE__*/_createTextVNode(" and password "),
    /*#__PURE__*/_createVNode("strong", null, "demo"),
    /*#__PURE__*/_createTextVNode(" to continue. ")
  ])
], -1)
const _hoisted_8 = { class: "fv-row mb-10" }
const _hoisted_9 = /*#__PURE__*/_createVNode("label", { class: "form-label fs-6 fw-bolder text-dark" }, "Email", -1)
const _hoisted_10 = { class: "fv-plugins-message-container" }
const _hoisted_11 = { class: "fv-help-block" }
const _hoisted_12 = { class: "fv-row mb-10" }
const _hoisted_13 = { class: "d-flex flex-stack mb-2" }
const _hoisted_14 = /*#__PURE__*/_createVNode("label", { class: "form-label fw-bolder text-dark fs-6 mb-0" }, "Password", -1)
const _hoisted_15 = /*#__PURE__*/_createTextVNode(" Forgot Password ? ")
const _hoisted_16 = { class: "fv-plugins-message-container" }
const _hoisted_17 = { class: "fv-help-block" }
const _hoisted_18 = { class: "text-center" }
const _hoisted_19 = {
  type: "submit",
  ref: "submitButton",
  id: "kt_sign_in_submit",
  class: "btn btn-lg btn-primary w-100 mb-5"
}
const _hoisted_20 = /*#__PURE__*/_createVNode("span", { class: "indicator-label" }, " Continue ", -1)
const _hoisted_21 = /*#__PURE__*/_createVNode("span", { class: "indicator-progress" }, [
  /*#__PURE__*/_createTextVNode(" Please wait... "),
  /*#__PURE__*/_createVNode("span", { class: "spinner-border spinner-border-sm align-middle ms-2" })
], -1)
const _hoisted_22 = /*#__PURE__*/_createVNode("div", { class: "text-center text-muted text-uppercase fw-bolder mb-5" }, " or ", -1)
const _hoisted_23 = /*#__PURE__*/_createVNode("a", {
  href: "#",
  class: "btn btn-flex flex-center btn-light btn-lg w-100 mb-5"
}, [
  /*#__PURE__*/_createVNode("img", {
    alt: "Logo",
    src: "media/svg/brand-logos/google-icon.svg",
    class: "h-20px me-3"
  }),
  /*#__PURE__*/_createTextVNode(" Continue with Google ")
], -1)
const _hoisted_24 = /*#__PURE__*/_createVNode("a", {
  href: "#",
  class: "btn btn-flex flex-center btn-light btn-lg w-100 mb-5"
}, [
  /*#__PURE__*/_createVNode("img", {
    alt: "Logo",
    src: "media/svg/brand-logos/facebook-4.svg",
    class: "h-20px me-3"
  }),
  /*#__PURE__*/_createTextVNode(" Continue with Facebook ")
], -1)
const _hoisted_25 = /*#__PURE__*/_createVNode("a", {
  href: "#",
  class: "btn btn-flex flex-center btn-light btn-lg w-100"
}, [
  /*#__PURE__*/_createVNode("img", {
    alt: "Logo",
    src: "media/svg/brand-logos/apple-black.svg",
    class: "h-20px me-3"
  }),
  /*#__PURE__*/_createTextVNode(" Continue with Apple ")
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_Field = _resolveComponent("Field")!
  const _component_ErrorMessage = _resolveComponent("ErrorMessage")!
  const _component_Form = _resolveComponent("Form")!

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode(_component_Form, {
      class: "form w-100",
      id: "kt_login_signin_form",
      onSubmit: _ctx.onSubmitLogin,
      "validation-schema": _ctx.login
    }, {
      default: _withCtx(() => [
        _createVNode("div", _hoisted_2, [
          _hoisted_3,
          _createVNode("div", _hoisted_4, [
            _hoisted_5,
            _createVNode(_component_router_link, {
              to: "/sign-up",
              class: "link-primary fw-bolder"
            }, {
              default: _withCtx(() => [
                _hoisted_6
              ]),
              _: 1
            })
          ])
        ]),
        _hoisted_7,
        _createVNode("div", _hoisted_8, [
          _hoisted_9,
          _createVNode(_component_Field, {
            class: "form-control form-control-lg form-control-solid",
            type: "text",
            name: "email",
            autocomplete: "off"
          }),
          _createVNode("div", _hoisted_10, [
            _createVNode("div", _hoisted_11, [
              _createVNode(_component_ErrorMessage, { name: "email" })
            ])
          ])
        ]),
        _createVNode("div", _hoisted_12, [
          _createVNode("div", _hoisted_13, [
            _hoisted_14,
            _createVNode(_component_router_link, {
              to: "/password-reset",
              class: "link-primary fs-6 fw-bolder"
            }, {
              default: _withCtx(() => [
                _hoisted_15
              ]),
              _: 1
            })
          ]),
          _createVNode(_component_Field, {
            class: "form-control form-control-lg form-control-solid",
            type: "password",
            name: "password",
            autocomplete: "off"
          }),
          _createVNode("div", _hoisted_16, [
            _createVNode("div", _hoisted_17, [
              _createVNode(_component_ErrorMessage, { name: "password" })
            ])
          ])
        ]),
        _createVNode("div", _hoisted_18, [
          _createVNode("button", _hoisted_19, [
            _hoisted_20,
            _hoisted_21
          ], 512),
          _hoisted_22,
          _hoisted_23,
          _hoisted_24,
          _hoisted_25
        ])
      ]),
      _: 1
    }, 8, ["onSubmit", "validation-schema"])
  ]))
}